export default "__VITE_ASSET__9wKeuo4P__"